import { createAction } from 'redux-actions'

export const enableGridView = createAction('ENABLE_GRID_VIEW')
export const disableGridView = createAction('DISABLE_GRID_VIEW')
